import { useSelector } from "react-redux";

import { resolveValueToConditionValueSelector } from "./valueSelectors.ts";

/**
 * Condition-value resolution over designer state, for a form that has to judge
 * an operand exactly as the build will. The trigger designer reads the same
 * selector for its own context; this is the route to it from anywhere else,
 * such as a node's own edit view.
 */
export const useResolveValueToConditionValue = () => useSelector(resolveValueToConditionValueSelector);
